/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSessionPhase } from './oralExamSessionPhase';

/**
 * Body for session_phase transitions (pre_flight -> in_exam, etc.).
 */
export interface OralExamTransitionPhaseRequest {
  sessionPhase: OralExamSessionPhase;
}
